import { useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";
import ActionButton from "../account/ActionButton";
import ScrollToTop from "../nav/ScrollToTop";
import SfsCategoryButton from "./SfsCategoryButton";
import SfsSummary from "./SfsSummary";
import SfsInputRow from "./SfsInputRow";

import { useSfs } from "../../context/SfsProvider";

function SfsExpenditureFixed({ handleNext, handleBack }) {
  /* The fixed expenditure component */

  const {
    sfsExpenditureFixed,
    setSfsExpenditureFixed,
    setSfsCategoryTotal,
    categories,
    setCategories,
    changeCategory,
    selectedCategory,
    setSelectedCategory,
    fixedValue
  } = useSfs();

  const setItem = (newItem) => {
    const newExpenditureFixedValues = sfsExpenditureFixed.map((item) =>
      item.category === newItem.category && item.title === newItem.title
        ? newItem
        : item
    );
    setSfsExpenditureFixed(newExpenditureFixedValues);
    setSfsCategoryTotal(newItem, newExpenditureFixedValues);
  };

  const titleText = (
    <span>
      {" "}
      <b>Monthly Expenditure Summary -</b> Fixed
    </span>
  );

  useEffect(() => {
    // Set data to fixed expenditure data on load
    if (sfsExpenditureFixed) {
      // Get unique array of categories in data
      const uniqueCategoryList = sfsExpenditureFixed
        .map((item) => item.category)
        .filter((value, index, self) => self.indexOf(value) === index);
      // Convert categories to objects with selected flag
      const uniqueCategories = uniqueCategoryList.map((item, idx) => ({
        name: item,
        selected: idx === 0 ? true : false,
      }));
      setCategories(uniqueCategories);
      setSelectedCategory(uniqueCategories[0].name);
    }
  }, []);

  return sfsExpenditureFixed && categories ? (
    <>
      <ScrollToTop />
      <Typography fontSize={22} paddingBottom={2}>
        <b>Expenditure</b> (Fixed)
      </Typography>
      <Stack
        sx={{
          mt: 2,
        }}
        spacing={8}
        direction={{
          xs: "column",
          md: "row",
        }}
      >
        <Box
          id='expenditure-fixed-container'
          sx={{ width: { xs: "100%", md: "55%" } }}
        >
          {/* Left column */}

          <Box sx={{ pb: 2 }}>
            {/* Sub category buttons */}
            {categories?.map((category, idx) => {
              return (
                <SfsCategoryButton
                  key={idx}
                  category={category}
                  changeCategory={changeCategory}
                />
              );
            })}
          </Box>

          <Box>
            {/* Sub category Inputs */}
            {sfsExpenditureFixed?.map((item, idx) =>
              item.category === selectedCategory ? (
                <SfsInputRow
                  key={idx}
                  item={item}
                  setItem={setItem}
                  maxValue={fixedValue[item.category]}
                />
              ) : null
            )}
          </Box>

          {/* End of left column */}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "45%" } }}>
          {/* Right column */}

          <SfsSummary id='monthly-expenditure-fixed-sum' title={titleText} />

          {/* Call To Action */}
          <Box sx={{
            pt: 4,
            textAlign: { xs: "center", md: "left" },
            display: "flex",
            flexDirection: "row",
          }}>
            <ActionButton
              id='back-btn'
              borderColor='primary.dark'
              buttonColor='transparent'
              buttonTextColor='primary.dark'
              buttonTitle='Back'
              variant='outlined'
              hoverColor='primary.dark'
              hoverBorderColor={"primary.dark"}
              hoverTextColor='secondary.contrastText'
              onClick={handleBack}
              sx={{ mr: 2 }}
            />
            <ActionButton
              id='save-continue-btn'          
              variant='contained'
              buttonColor='secondary.main'
              buttonTextColor='primary.contrastText'
              borderColor='transparent'
              hoverColor='primary.contrastText'
              hoverBorderColor='secondary.main'
              hoverTextColor='secondary.main'
              buttonTitle='Next'
              onClick={handleNext}
            />

          </Box>

          {/* End of right column */}
        </Box>
      </Stack>
    </>
  ) : null;
}

export default SfsExpenditureFixed;
